import { PRO_PAGE_ROUTE_PER_PRO_TYPE } from '@application/constants';
import { translatedFieldWithFallback, useRouter } from '@application/utils';
import type { ProGetRelatedProfessionalsQuery } from '@gql/graphql';
import { ProfessionalTypeEnum } from '@gql/graphql';
import { useMemo } from 'react';

export const useFormatRelatedPros = (
  pros?: ProGetRelatedProfessionalsQuery['relatedProfessionals']['pros'],
) => {
  const { language, routeLocationDescriptor } = useRouter();
  const formattedPros = useMemo(() => {
    if (!pros?.length) return;
    return pros.map((pro) => {
      const name = translatedFieldWithFallback(language, pro?.translations, 'title') ?? '-';
      const url = translatedFieldWithFallback(language, pro?.translations, 'url');

      const link = routeLocationDescriptor(
        PRO_PAGE_ROUTE_PER_PRO_TYPE[pro?.type ?? ProfessionalTypeEnum.VET],
        {
          params: [url ?? ''],
        },
      );
      return {
        label: name,
        link,
      };
    });
  }, [language, pros, routeLocationDescriptor]);

  return { formattedPros };
};
